<template>
  <tabs parent="settings">
    <tab id="ai" :name="translate('settings.ai')" :href="url + '/ai'">
      <keep-alive>
        <Ai />
      </keep-alive>
    </tab>
    <tab id="parameters" :name="translate('settings.parameters')" :href="url + '/parameters'">
      <keep-alive>
        <Parameters />
      </keep-alive>
    </tab>
    <tab id="database_status" :name="translate('settings.database_status')" :href="url + '/database_status'">
      <keep-alive>
        <DatabaseStatus />
      </keep-alive>
    </tab>
  </tabs>
</template>

<script>
import {Tabs, Tab} from 'components/UIComponents/Tabs'
import Ai from './Tabs/Ai/Index.vue'
import Parameters from './Tabs/Parameters/Index.vue'
import DatabaseStatus from './Tabs/DatabaseStatus/Index.vue'

export default {
  name: 'Settings',
  components: {
    Tabs,
    Tab,
    Ai,
    Parameters,
    DatabaseStatus
  },
  computed: {
    url () { return '/settings' }
  }
}
</script>
